import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { SymbolClientAction } from '@cbridge-packages/symbol-client';
import { MultiSelectSidebarAction } from '@cbridge-packages/multi-select-sidebar';

export const closeBulkEditSidebarOnDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    SymbolClientAction.bulkRemove.done,
  ),
  mergeMap(() => [
    MultiSelectSidebarAction.closeBulkEditSidebar(),
    MultiSelectSidebarAction.clearSelection(),
  ]),
);
